import React from "react";

import classnames from "classnames";
import style from "./style.module.scss";

interface Props {
    children?: JSX.Element | JSX.Element[];
    image: ImageQueryResponse;
    title: string;
    viewMode: CarouselViewMode;
    headerVariant?: boolean;
}

export const CarouselSlide = (props: Props): JSX.Element => {
    const { children, image, title, viewMode, headerVariant = false } = props;

    return (
        <div
            className={classnames(
                style.slide,
                image &&
                    style[
                        `slide__${viewMode?.toLowerCase() === "background" ? "image-text" : viewMode?.toLowerCase()}`
                    ],
                headerVariant && style.headerVariant,
            )}
            data-test-id={`CarouselSlide.${title}`}
        >
            <div className={style.content}>
                <div className={style.text}>{children}</div>
                {image && <div className={style.image}>{image}</div>}
            </div>
        </div>
    );
};
